import React, { useState } from "react";

const TableFour6 = props => {
  const API = props.API;
  const [editable, setEditable] = useState(false);
  const [editable1, setEditable1] = useState(false);
  const [editable2, setEditable2] = useState(false);

  const [professional, setProfessional] = useState("");
  const [publication, setPublication] = useState("");
  const [participation, setParticipation] = useState("");

  const changeData = (type, val) => {
    switch (type) {
      case "PROFESSIONAL":
        setProfessional(val);
        break;
      case "PUBLICATION":
        setPublication(val);
        break;
      case "PARTICIPATION":
        setParticipation(val);
        break;
      default:
        console.log("Default");
    }
  };

  return (
    <div>
      <h1>4.6. Professional Activities (20) </h1>
      <h2>
        4.6.1. Professional societies/chapters and organizing engineering events
        (5)
      </h2>
      <p>(The Department shall provide relevant details)</p>
      {editable ? (
        <textarea
          row="3"
          type="text"
          value={professional}
          onChange={e => changeData("PROFESSIONAL", e.target.value)}
        />
      ) : (
        <p>{professional}</p>
      )}
      {editable ? null : (
        <button onClick={() => setEditable(true)}>Edit</button>
      )}
      &nbsp;
      <button
        onClick={() => {
          setEditable(false);

          var data = {
            professional
          };
          console.log(data);
        }}
      >
        Submit
      </button>
      <h2>4.6.2. Publication of technical magazines, newsletters, etc. (5)</h2>
      <p>
        (The Department shall list the publications mentioned earlier along with
        the names of the editors, publishers, etc.)
      </p>
      {editable1 ? (
        <textarea
          row="3"
          type="text"
          value={publication}
          onChange={e => changeData("PUBLICATION", e.target.value)}
        />
      ) : (
        <p>{publication}</p>
      )}
      {editable ? null : (
        <button onClick={() => setEditable1(true)}>Edit</button>
      )}
      &nbsp;
      <button
        onClick={() => {
          setEditable1(false);

          var data = {
            publication
          };
          console.log(data);
        }}
      >
        Submit
      </button>
      <h2>
        4.6.3 Participation in inter-institute events by students of the program
        of study (10)
      </h2>
      <p>
        (The Department shall provide a table indicating those publications,
        which received awards in the events/conferences organized by other
        institutes.)
      </p>
      {editable2 ? (
        <textarea
          row="3"
          type="text"
          value={participation}
          onChange={e => changeData("PARTICIPATION", e.target.value)}
        />
      ) : (
        <p>{participation}</p>
      )}
      {editable2 ? null : (
        <button onClick={() => setEditable2(true)}>Edit</button>
      )}
      &nbsp;
      <button
        onClick={() => {
          setEditable2(false);

          var data = {
            participation
          };
          console.log(data);
        }}
      >
        Submit
      </button>
    </div>
  );
};

export default TableFour6;
